import { useEffect } from "react";
import { Typography, Box } from "@mui/material";
import { useBreadcrumb } from "../../../contexts/BreadcrumbContext.jsx";
import InsurersTable from "../../../components/tables/InsurersTable.jsx";
import {
  ContentDialog,
  ContentDialogInit,
} from "components/MDDForm/components/ContentDialog.jsx";
import Form from "../../../components/Form/Form.jsx";
import FormTextField from "../../../components/Form/FormTextField.jsx";
import SubmitButton from "../../../components/Form/SubmitButton.jsx";
import { useInsurerActions } from "../../../hooks/useInsurerActions.jsx";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useInsurerPermissions } from "../../../hooks/permissions/useInsurerPermissions.jsx";

/**
 * Insurers List Page
 * Shows a list of insurers with email editing functionality
 */
export default function InsurerIndexPage() {
  const { setBreadcrumbs } = useBreadcrumb();
  const { openCD, setOpenCD, tca, setTca, CDActions, setCDActions } =
    ContentDialogInit();

  const { canUpdateEmail } = useInsurerPermissions();
  const { updateEmail } = useInsurerActions();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Versicherungsgesellschaften", path: "/admin/insurers" },
    ]);
  }, [setBreadcrumbs]);

  const closeDialog = () => {
    setOpenCD(false);
  };

  const openEditEmailModal = (row) => {
    if (!canUpdateEmail(row)) {
      return;
    }

    showEditEmailModal(row, "E-Mail-Adresse bearbeiten");
  };

  const showEditEmailModal = (insurer, title) => {
    console.log(insurer);
    const validationSchema = yup.object({
      email: yup
        .string()
        .email("Ungültige E-Mail-Adresse")
        .required("E-Mail-Adresse ist erforderlich"),
    });

    setOpenCD(true);
    setTca({
      title: title,
      content: (
        <Form
          defaultValues={{
            email: insurer.ansprechpartner_ge?.email || "",
          }}
          onSubmit={async (formData, formMethods) => {
            try {
              await updateEmail(insurer.id, formData);
              closeDialog();
              return true;
            } catch (error) {
              if (formMethods.setError) {
                console.error("Error updating email:", error);
              }
              return false;
            }
          }}
          resolver={yupResolver(validationSchema)}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              minWidth: 400,
            }}
          >
            <Typography variant="body2" color="text.secondary">
              Versicherungsgesellschaft: <strong>{insurer.name}</strong>
            </Typography>
            <FormTextField
              name="email"
              label="E-Mail-Adresse"
              type="email"
              required
              fullWidth
            />
            <Box
              sx={{
                display: "flex",
                gap: 1,
                justifyContent: "flex-end",
                mt: 2,
              }}
            >
              <SubmitButton variant="primary">Speichern</SubmitButton>
            </Box>
          </Box>
        </Form>
      ),
      actions: null,
    });
  };

  return (
    <>
      <Box>
        <InsurersTable
          pageTitle="Versicherungsgesellschaften"
          pageSubtitle="Übersicht aller Versicherungsgesellschaften mit Kontaktdaten"
          onRowClick={openEditEmailModal}
        />
      </Box>
      <ContentDialog
        openCD={openCD}
        setOpenCD={setOpenCD}
        CDActions={CDActions}
        tca={tca}
      />
    </>
  );
}
